const outlineStyle = {
    fill: 'none',
    stroke: '#888',
    strokeMiterlimit: 10,
    strokeWidth: 1.5
}

const FilterModern = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.12 25.12"><g id="a"/><g id="b"><g id="c"><rect style={outlineStyle} x=".75" y=".75" width="23.62" height="23.62" rx="4.07" ry="4.07"/><g><line style={outlineStyle} x1="5.07" y1="7.9" x2="20.05" y2="7.9"/><line style={outlineStyle} x1="7.18" y1="12.56" x2="17.95" y2="12.56"/><line style={outlineStyle} x1="8.65" y1="17.22" x2="16.47" y2="17.22"/></g></g></g></svg>
    )
}

export default FilterModern
